export enum FeatureFlagsEnum {
    AdsIntelIcpAgent = 'ads-intel-icp-agent',
    BomboraIntentAutomations = 'bombora-intent-automations',
    BuyingCenterEnrichment = 'buying-center-enrichment',
    CopilotSearch = 'copilot-search',
    CrmOwnedContacts = 'por-2641-crm-owned-contacts',
    FormsIntelUnhide = 'forms-intel-unhide',
    GTMCanvas = 'GTMCanvas',
    HsEnrichment = 'hs-enrichment',
    HubspotCrm = 'hubspot-crm',
    HubspotLargeExports = 'hub-spot-large-exports',
    HubSpotOwnedContacts = 'hub-spot-owned-contacts',
    ICPIntel = 'ICPIntel',
    ICPIntelV2Model = 'icp-intel-v-2-model',
    IdealCustomerProfileAutomations = 'ideal-customer-profile-automations',
    IntentAutomations = 'intent-automations',
    IntentAutomationsBuyingCenter = 'intent-automations-buying-center',
    LaunchSignalAutomation = 'launch-signal-automation',
    SignalAutomation = 'signal-automation',
    JobChangeExport = 'job-change-export',
    LaunchProspectConnect = 'launch-prospect-connect',
    ListEnrichment = 'list-enrichment',
    LocationFilters = 'location-filters',
    RepIntel = 'RepIntel',
    ReportingDashboard = 'reporting-dashboard',
    SalesforceIntegrationsForLargeExports = 'salesforce-integrations-for-large-exports',
    SessionLogout = 'session-logout',
    TechEnrichment = 'tech-enrichment',
    TechSpendFilter = 'tech-spend-filter',
    VisitorIntelAutomations = 'visitor-intel-automations',
    VisitorIntelRedux = 'visitor-intel-redux',
    WebsocketsSf = 'websockets-sf',
    GeneratedContent = 'generated-content',
}
